import axios from '@/fetch/index';
import config from '@/fetch/config/index';
const { get, post, put, del } = axios;
const { relApi } = config;

// 获取渠道配置->不需要token
export function getWebsiteConfig(data) {
  return get(`${relApi}/ai-customer-service/cs/visitor/config/all/${data.childChannelId}?companyId=${data.companyId}`)
}




// WEBPACK FOOTER //
// ./src/services/systemSetting.js